import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { IconPlus, IconX } from '@tabler/icons-react'
import { v4 as uuidv4 } from 'uuid';
import { CustomSelectCustomOptionOption, SelectCustomLoadingSearching, loadOptionProps, loadOptionReturnProps, loadSelectedOptionProps, loadSelectedOptionReturnProps } from '../../../../components/input_loading_searching';
import { Product, ProductCategory, ProductImage, Store, Warehouse, RackKeys, employee, Rack, BinItem, BinItemKeys, } from '../../../../../../../types';
import useFormValidatonCustom, { validationObject } from '../../../../../../../hooks/form_validation_hook';
import { useRESTapi } from '../../../../../../../hooks/rest_API';
import { RootState } from '../../../../../../../redux/store';
import { useParams } from 'react-router-dom';
import { AdminModal, AdminModalContent, AdminModalFooter, AdminModalHeader, AdminModalMiddle, AdminModalTitle } from '@/src/pages/admin/components/modal';
import { Input } from '@/src/components/ui/input';
import { Switch } from '@/src/components/ui/switch';
import { Button } from '@/src/components/ui/button';




type RackOverview = BinItem

type imageIds = string[]



export function AddBinModal(
    {
        show,
        closeModal,
        id,
        updateUi,
        mode,
        setShow
    }:
        {
            show: boolean,
            setShow: (show: boolean) => any,
            closeModal: () => void,
            id?: string,
            updateUi: () => void,
            mode: 'add' | 'edit',
        }
) {

    const { warehouseId, storeId, rackId } = useParams()


    const validationObject = {
        [BinItemKeys.I08_Capacity]: {
            message: '',
            validation: [
                (value) => {

                    if (!value) {
                        return 'required'
                    }
                    return true
                }
            ]
        },
        [BinItemKeys.I08_Name]: {
            message: '',
            validation: [
                (value) => {

                    if (!value) {
                        return 'required'
                    }
                    return true
                }
            ]
        },


    } satisfies validationObject

    const api = useRESTapi();
    const employee = useSelector((state: RootState) => state.employee)
    const [formData, setFormData] = useState<RackOverview>({
        I08_Capacity: 0,
        I08_Description: '',
        I08_M15_created_by: '',
        I08_Name: '',
        I03_is_active:1
    })
    const [isLoading, setIsLoading] = useState(false)
    const { performAllValidation, performValidationOf, errorData, setErrorData } = useFormValidatonCustom<BinItem>({
        validationObject: validationObject
    })
    const [loading, set_loading] = useState(false)



    function handleChangeInput(e: React.ChangeEvent<HTMLInputElement>) {

        let formdata: BinItem;

        switch (e.target.name) {


            default:
                formdata = {
                    ...formData,
                    [e.target.name]: e.target.value
                }
                break;
        }




        setFormData(formdata)
        performValidationOf(e.target.name, formdata)
        console.log(formdata)

    }

    async function add_bin() {

        setIsLoading(true)
        // formData.M11_created_by = employee.M15_Employee_id!
        if (performAllValidation(formData) === true) {

            try {

                const formDataReal = new FormData();
                formData.I08_M15_created_by = employee.employeeData.M15_Employee_id!
                formData.I08_I03_Rack_id = rackId!
                formData.I08_Description = formData.I08_Name

                console.log(formData)
                Object.entries(formData).map(
                    data => {


                        formDataReal.append(data[0], String(data[1]))

                    }
                )

                // const anyFormData  = formData as any

                // for (const key in formData) {
                //     formDataReal.append(key, String(anyFormData[key]))
                // }

                const res = await api.post<{ success: boolean, data: Store, errors: any, message: string }>({
                    url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/bin`,
                    body: formDataReal,
                    mode: 'admin'
                })

                if (res.data.success === true) {

                    updateUi();
                    alert(res.data?.message || 'added rack')
                    closeModal()

                } else {
                    alert(res.data?.message || 'something went wrong')
                    if (res.data.errors) {

                        const errs = res.data.errors;
                        const errData: any = {}

                        for (const key in errs) {
                            errData[key] = errs[key][0]
                        }

                        setErrorData(errData)

                    }

                }
            } catch (error) {
                console.log(error)
            }
        }
        setIsLoading(false)

    }
    async function edit_bin() {

        setIsLoading(true)
        // formData.M11_created_by = employee.M15_Employee_id!
        if (performAllValidation(formData) === true) {

            try {

                const formDataReal = new FormData();
                formData.I08_I03_Rack_id = rackId!
                formData.I08_Description = formData.I08_Name
                formData.I08_M15_created_by = employee.employeeData.M15_Employee_id!
                formDataReal.append('_method', "PUT")

                Object.entries(formData).map(
                    data => {

                        formDataReal.append(data[0], String(data[1]))

                    }
                )



                const res = await api.post<{ success: boolean, data: BinItem, errors: any, message: string }>({
                    url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/bin/${id}`,
                    body: formDataReal,
                    mode: 'admin'
                })

                if (res.data.success === true) {

                    updateUi();
                    alert(res.data?.message || 'updated store')
                    setShow(false)

                } else {
                    alert(res.data?.message || 'something went wrong')
                    if (res.data.errors) {

                        const errs = res.data.errors;
                        const errData: any = {}

                        for (const key in errs) {
                            errData[key] = errs[key][0]
                        }

                        setErrorData(errData)

                    }

                }
            } catch (error) {
                console.log(error)
            }
        }
        setIsLoading(false)

    }


    const fetch_selected_Employee: (props: loadSelectedOptionProps) => Promise<loadSelectedOptionReturnProps<employee & CustomSelectCustomOptionOption>> = async (props: loadSelectedOptionProps) => {
        if (props.value) {
            const res = await api.get<{ success: boolean, data: employee, errors: any, message: string }>({
                url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/Employees/${props.value}`,
                mode: 'admin'
            })

            if (res.data.success === false) {

                alert(res.data?.message || 'something went wrong')
                return {
                    options: null
                }
            } else {

                // alert(res.data.message)
                return {
                    options: {
                        ...res.data.data,
                        name: res.data.data.M15_Name,
                        value: res.data.data.M15_Employee_id,

                    } as (employee & CustomSelectCustomOptionOption)
                }
            }
        }
        return {
            options: null
        }
    }


    const load_bin = async () => {

        const res = await api.get<{ success: boolean, data: BinItem, message?: string }>({
            url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/bin/${id}`,
            mode: 'admin'
        })
        if (res.data.success === true) {
            // images_url.images = res.data.data.images ? res.data.data.images : []

            // res.data.data.M11_ProductImages = []
            setFormData(res.data.data)
        } else {
            throw res.data
        }


    }




    useEffect(
        () => {

            const initListSetup = () => {
                set_loading(true)
                setFormData({
                    I08_Capacity: 0,
                    I08_Description: '',
                    I08_M15_created_by: '',
                    I08_Name: '',
                    I03_is_active:1
                })
                setErrorData({})
                set_loading(false)

            }
            const initEditSetup = () => {
                set_loading(true)

                Promise.all(
                    [load_bin()]
                ).then(
                    () => {
                        set_loading(false)

                    }
                ).catch(
                    (err) => {
                        set_loading(false)

                    }
                )

            }

            if (mode === 'add' && show === true) {
                setErrorData({})
                initListSetup()
            } else if (mode === 'edit' && show === true) {
                initEditSetup()
                // initListSetup()

            } else {
                set_loading(true)
            }


        }, [show]
    )



    return (

        <AdminModal show={show} setShow={setShow} >
            <AdminModalContent>
                <AdminModalHeader>
                    <AdminModalTitle>{mode === 'add' ? 'Add Bin' : 'Edit Bin'}</AdminModalTitle>
                </AdminModalHeader>
                <AdminModalMiddle>
                    <Input disabled={loading || isLoading} value={formData.I08_Name} onChange={handleChangeInput} type="text" name={BinItemKeys.I08_Name} placeholder='Bin name' />
                    <div className=' text-red-500'>{errorData.I08_Name ? errorData.I08_Name : null}</div>
                    <div className=' min-h-2'></div>
                    <Input disabled={loading || isLoading} value={formData.I08_Capacity} onChange={handleChangeInput} type="number" name={BinItemKeys.I08_Capacity} placeholder='Bin name' />
                    <div className=' text-red-500'>{errorData.I08_Capacity ? errorData.I08_Capacity : null}</div>
                    <div className=' min-h-2'></div>
                    <div className=' flex gap-1'>
                        {/* <Input checked={formData.I03_is_active === 1 ? true : false} type="checkbox" name={RackKeys.I03_is_active} onChange={handleChangeInput} /> */}
                        <Switch disabled={loading || isLoading} checked={formData.I03_is_active === 1 ? true : false} name={RackKeys.I03_is_active} onCheckedChange={(checked) => handleChangeInput({
                            target: {
                                name: BinItemKeys.I03_is_active,
                                value: checked ? 1 : '0',
                                checked: checked
                            }
                        } as React.ChangeEvent<HTMLInputElement>)} />
                        <div>is active</div>
                    </div>

                    <AdminModalFooter>
                        <Button variant={'outline'} disabled={isLoading} onClick={closeModal}  >Cancel</Button>
                        {
                            mode === 'add' ?
                                <Button disabled={isLoading || loading} onClick={add_bin}  >{isLoading ? 'adding...' : 'Add'}</Button>
                                :
                                <Button disabled={isLoading || loading} onClick={edit_bin}  >{isLoading ? 'editing...' : 'edit'}</Button>}

                    </AdminModalFooter>
                </AdminModalMiddle>
            </AdminModalContent>
        </AdminModal>
    )

}
